module.exports = __webpack_public_path__ + "img/Ali_03.cc0271a5.png";